var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { observable } from "mobx";
import { InternalMessageBusChannels } from "sb-internal-msg-bus";
export class TimeZoneObservable {
    constructor(messageBus) {
        this.observers = [];
        this.currentTimeZone = observable.box(0);
        this.subscription = () => { };
        this.messageBus = messageBus;
        this.messageBus.emit(InternalMessageBusChannels.legacy.timeZone.request, { callback: (message) => this.updateTimeZone(message) });
    }
    activate() {
        this.subscription = this.messageBus.getSubscription(InternalMessageBusChannels.legacy.timeZone.update, (message) => this.updateTimeZone(message.data[0]), this);
    }
    observe(action) {
        return __awaiter(this, void 0, void 0, function* () {
            yield action(this.currentTimeZone.get());
            this.observers.push(this.currentTimeZone.observe((change) => action(change.newValue)));
        });
    }
    updateTimeZone(message) {
        this.currentTimeZone.set(message.currentSelectedTimeZone);
    }
    deactivate() {
        this.subscription();
        this.observers.forEach(x => x());
        this.observers.splice(0, this.observers.length);
    }
}
//# sourceMappingURL=TimeZoneObservable.js.map